import './style.scss';

import React, { useCallback, useContext } from 'react';
import { Checkbox, CheckboxProps } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { toggleDirectCommunicationMode } from 'app/redux/xrayGeneratorConfiguration/actions';
import { selectIsDirectCommunicationMode } from 'app/redux/xrayGeneratorConfiguration/reducer';
import XRayGeneratorManagerContext from 'app/providers/XRayGeneratorManagerProvider/context';
import TechnicianPasswordValidationContext from 'app/providers/TechnicianPasswordValidationProvider/context';
import { Toggle, ToggleProps } from 'rsuite';

const CommnunicationModeConfiguration = React.memo(() => {
  const xRayGeneratorManager = useContext(XRayGeneratorManagerContext);
  if (!xRayGeneratorManager) return null;

  const dispatch = useDispatch();
  const intl = useIntl();
  const requestValidation = useContext(TechnicianPasswordValidationContext);
  const isDirectCommunicationMode: boolean = useSelector(selectIsDirectCommunicationMode) ?? false;

  const onChangeCommunicationMode: ToggleProps['onChange'] = useCallback(
    (checked, event) =>
      requestValidation()
        .then(() => dispatch(toggleDirectCommunicationMode(checked)))
        .catch(() => {}),
    [dispatch, requestValidation]
  );

  return (
    <div>
      <Toggle
        checked={isDirectCommunicationMode}
        size="lg"
        checkedChildren={intl.formatMessage({
          id: 'account.xray_generator.communication_mode.modbus',
        })}
        unCheckedChildren={intl.formatMessage({
          id: 'account.xray_generator.communication_mode.carte_protocole',
        })}
        onChange={onChangeCommunicationMode}
      />
    </div>
  );
});

export default CommnunicationModeConfiguration;
